skrilla.controller('creditCardDetailsCtrl', function ($scope, searchService, $stateParams, srefService, modalService, cacheService) {
    $scope.key = "creditCardDetails";
    $scope.get = function(){
        searchService.get('creditCards/' + $stateParams.id).then(function(response){
            $scope.card = response.data;
            $scope.tableData = {
                columns: [
                    {title:"Username", field: "username", onClick: clickUsername, isUsernameLink: true},
                    {title:"First Name", field: "firstName"},
                    {title:"Last Name", field: "lastName"},
                    {title:"Card Name", field:"name"},
                    {title:"Active", field: "active"},
                    {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}},
                ],
                isSkrillaTable: true,
                data: $scope.card.implementations
            }
        });
    }
    $scope.get();

    $scope.update = function(){
        cacheService.registerObject("creditCard", $scope.card)
        modalService.openModal("views/creditCardDetails/deactivateCardModal.html", true, 'lg', true, true, function(){ $scope.get(); });
    }

    function clickUsername(bet, field, event){
        srefService.go("userDetails", {id: bet.userId}, event);
    }

    $scope.getCardNumber = function () {
        if ($scope.card) {
            const startNumber = $scope.card.implementations.find(card => card.bin !== undefined)?.bin || $scope.card.implementations[0].numberFirst
            return startNumber.substring(0, 4) + " " + startNumber.substring(4, 6).padEnd(4, '*') + " **** " + $scope.card.implementations[0].numberLast
        } else return ""
    }

});

